import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFilteredUserUIDs, getCurrentUser } from '../selectors';
import UserRow from './UserRow';
import '../styles/UsersTable.css';

const UsersTable = ({ users, userUID }) => (
  <table className="UsersTable bg-white">
    <thead>
      <tr>
        <th>
          <button type="button" className="moon-gray b ttu tracked f7">Name</button>
        </th>
        <th>
          <button type="button" className="moon-gray b ttu tracked f7">Email</button>
        </th>
        <th>
          <button type="button" className="moon-gray b ttu tracked f7">Group</button>
        </th>
        <th>
          <button type="button" className="moon-gray b ttu tracked f7">City</button>
        </th>
        <th>
          <button type="button" className="moon-gray b ttu tracked f7">Event Day</button>
        </th>
        <th>
          <button type="button" className="moon-gray b ttu tracked f7">Results</button>
        </th>
        <th />
      </tr>
    </thead>
    <tbody>
      {users.map(userUIDRow => {
        if (userUIDRow === userUID) {
          return null;
        }

        return <UserRow key={userUIDRow} userUID={userUIDRow} />
      })}
    </tbody>
  </table>
);

UsersTable.propTypes = {
  users: PropTypes.arrayOf(PropTypes.string).isRequired,
  userUID: PropTypes.string.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    user: getCurrentUser(state),
    users: getFilteredUserUIDs(state, ownProps),
    userUID: state.userUID,
  };
}

export default connect(mapStateToProps)(UsersTable);



// WEBPACK FOOTER //
// ./src/components/UsersTable.js